/** All available mailing attachments (documents, bills etc.) statuses */
export enum MailingAttachmentStatusEnum {
  /** Attachment not sent yet */
  NOT_SENT = 'NOT_SENT',
  /** Attachment already sent */
  SENT = 'SENT',
}
